import React from 'react'

const Loading = () => {
    return (
        <>
            <div className='h-[50vh] flex items-center justify-center'>
                <div class="three-body">
                    <div class="three-body__dot"></div>
                    <div class="three-body__dot"></div>
                    <div class="three-body__dot"></div>
                </div>
            </div>

        </>
    )
}

export default Loading